import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from '../../services/session'
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const LocService = new Loc()
const AdminApiService = new AdminApi()


export default {
    data() {
        return {
            locale: LocService,
            id: 0,
            name: '',
            allCustomCategories: [],
            selectedCustomCategories: [],
            model: {
                companyName: '',
                host: null,
                deviceId: null,
                location: null
            }
        }

    },
    methods: {
        update: update,
        isNull: isNull,
        getChipClass: getChipClass,
        clickSelectCustomCategory: clickSelectCustomCategory,
        isSelected: isSelected,

        getDoorCompanyConfiguration: getDoorCompanyConfiguration,
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.allCustomCategories = session.getConfig().customCategories.split(";");
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        this.model.companyName = this.$route.query.name;
        this.getDoorCompanyConfiguration()
    }
}

function getDoorCompanyConfiguration() {
    let _self = this;
    var location = '';
    if (this.selectedCustomCategories.length > 0) {
        location = this.selectedCustomCategories[0];
    }
    AdminApiService.getDoorCompanyConfiguration(this.name, location)
        .then((response) => {
            _self.model.companyName = _self.isNull(response.data.companyName, '');
            _self.model.host = _self.isNull(response.data.host, null);
            _self.model.deviceId = _self.isNull(response.data.deviceId, null);
            _self.id = _self.isNull(response.data.id, null);
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function isNull(value, def) {
    if (value == null) return def
    return value
}


function update() {
    let _self = this;
    var location = null;
    if (this.selectedCustomCategories.length > 0) {
        location = this.selectedCustomCategories[0];
    }
    this.model.companyName = this.name;
    this.model.location = location;
    if (this.id != null) {
        this.model.id = this.id;
    }
    AdminApiService.updateDoorConfiguration(this.model)
        .then((response) => {
            swal('Success', 'Konfiguracija ažurirana', 'success')
            _self.getDoorCompanyConfiguration();
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getChipClass(item) {
    if (this.selectedCustomCategories.includes(item)) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item) {
    return this.selectedCustomCategories.includes(item)
}

function clickSelectCustomCategory(item) {
    if (this.selectedCustomCategories.includes(item)) {
        this.selectedCustomCategories = this.selectedCustomCategories.filter(e => e !== item)
    } else {
        this.selectedCustomCategories = []
        this.selectedCustomCategories.push(item)
    }
    this.getDoorCompanyConfiguration();
}



// WEBPACK FOOTER //
// ./src/components/Company/DoorConfiguration.js